const WineGlassSmallIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Glass bowl */}
      <path 
        d="M9 3 C9 3, 8 8, 8 12 C8 16, 10 19, 13 20.5 L13 20.5 C14 21, 15 21.5, 15.5 21.7 L15.5 27 M16.5 21.7 C17 21.5, 18 21, 19 20.5 C22 19, 24 16, 24 12 C24 8, 23 3, 23 3" 
        stroke="currentColor" 
        strokeWidth="1.8" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Glass rim */}
      <path 
        d="M9 3 L23 3" 
        stroke="currentColor" 
        strokeWidth="1.8" 
        strokeLinecap="round"
      />
      
      {/* Stem */}
      <path 
        d="M16 21.7 L16 27" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      
      {/* Base */}
      <path 
        d="M12 27 L20 27" 
        stroke="currentColor" 
        strokeWidth="1.8" 
        strokeLinecap="round"
      />
      <ellipse 
        cx="16" 
        cy="27" 
        rx="4" 
        ry="0.8" 
        fill="currentColor" 
        opacity="0.3"
      />
      
      {/* Wine liquid */}
      <path 
        d="M10 9 C10 9, 12 10, 14 10.5 C15 11, 17 11, 18 10.5 C20 10, 22 9, 22 9 L22 12 C22 14.5, 20.5 16.5, 19 17.5 C17.5 18.5, 14.5 18.5, 13 17.5 C11.5 16.5, 10 14.5, 10 12 Z" 
        fill="currentColor"
        opacity="0.2"
      />
      
      {/* Wine surface */}
      <ellipse 
        cx="16" 
        cy="10" 
        rx="6" 
        ry="1.5" 
        fill="currentColor"
        opacity="0.35"
      />
    </svg>
  );
};

export default WineGlassSmallIcon;
